export default "__VITE_ASSET__9708eb3d__"